import { PropsWithChildren } from 'react';
import { useApiState } from '@features/maintenance-mode/useApiState';
import { MaintenanceMessage } from '@features/maintenance-mode/MaintenanceMessage';

export function MaintenanceModeWrapper(props: PropsWithChildren) {
    const apiState = useApiState();

    if (apiState.maintenance) return <MaintenanceMessage />;

    return <>{props?.children ?? null}</>;
}
